import { useFonts } from 'expo-font'

export const FontsWeb = () => {
  useFonts({
    'SFPro-Expanded-Bold': require('../../../../fonts/SFPro-Expanded-Bold.ttf'),
    'SFPro-Expanded-Heavy': require('../../../../fonts/SFPro-Expanded-Heavy.ttf'),
    Montserrat: require('@expo-google-fonts/montserrat/Montserrat_400Regular.ttf'),
    'Montserrat-Medium': require('@expo-google-fonts/montserrat/Montserrat_500Medium.ttf'),
    'Montserrat-SemiBold': require('@expo-google-fonts/montserrat/Montserrat_600SemiBold.ttf'),
    'Montserrat-Bold': require('@expo-google-fonts/montserrat/Montserrat_700Bold.ttf'),
  })
  return null
}
